import { create } from 'zustand'

export type FileInfoListStore_Type = {
    upload_date: string;
    upload_file_pk: number;
    is_can_download: boolean;
}
// 1. 상태(Data)와 액션(Functions)의 타입을 분리하여 정의
interface FileInfoListStoreState_Type {
    fileInfoList: FileInfoListStore_Type[];
    selected_index: number;
    is_disabled: boolean;
}

interface FileInfoListStoreActions_Type {
    // 단순 'set' 대신 'update'나 'setImages'처럼 명확한 행위 명명
    setFileInfoList: (fileInfoList: FileInfoListStore_Type[]) => void;

    // 리스트 초기화와 같은 자주 쓰이는 로직은 액션으로 미리 정의
    clearFileInfoList: () => void;

    setSelectedIndex: (index: number) => void;

    setIsDisabled: (isDisabled: boolean) => void;
}

// 2. 스토어 생성
const useFileInfoListStore = create<FileInfoListStoreState_Type & FileInfoListStoreActions_Type>()((set) => ({
    // --- State ---
    fileInfoList: [],
    selected_index: 0,
    is_disabled: false,
    // --- Actions ---
    // 불필요한 화살표 함수 중첩을 줄이고 간결하게 작성
    setFileInfoList: (fileInfoList) => (
        set({ fileInfoList: fileInfoList })
    ),

    // 리스트 초기화
    clearFileInfoList: () => (
        set({ fileInfoList: [] })
    ),

    setSelectedIndex: (index) => (
        set({ selected_index: index })
    ),

    setIsDisabled: (isDisabled) => (
        set({ is_disabled: isDisabled })
    ),
}));

export default useFileInfoListStore;